import { useEffect, useRef, useState } from "react";
import {
    FaCrown,
    FaGem,
    FaAward,
    FaMedal,
    FaBook,
    FaEnvelope,
    FaUserTie,
    FaLandmark,
    FaStore,
} from "react-icons/fa";

import styles from "./SponsorsPage.module.css";

const TIERS = [
    {
        key: "platinum",
        name: "Platinum Sponsor",
        price: "20,00,000",
        accent: "#7c9cbf",
        icon: <FaCrown />,
        featured: true,
        benefits: [
            "Exhibition stall at the conference venue",
            "Free registration for 6 delegates",
            "Logo and name displayed at the stage backdrop",
            "Acknowledgement on the inside back-cover of the souvenir",
        ],
    },
    {
        key: "diamond",
        name: "Diamond Sponsor",
        price: "15,00,000",
        accent: "#0ea5e9",
        icon: <FaGem />,
        benefits: [
            "Exhibition stall at the conference venue",
            "Free registration for 5 delegates",
            "Logo and name displayed at the stage backdrop",
            "Acknowledgement on the inside back-cover of the souvenir",
        ],
    },
    {
        key: "gold",
        name: "Gold Sponsor",
        price: "10,00,000",
        accent: "#d97706",
        icon: <FaAward />,
        benefits: [
            "Exhibition stall at the conference venue",
            "Free registration for 4 delegates",
            "Logo and name displayed at the stage backdrop",
            "Special full-page multi-colour advertisement in the souvenir",
        ],
    },
    {
        key: "silver",
        name: "Silver Sponsor",
        price: "5,00,000",
        accent: "#94a3b8",
        icon: <FaMedal />,
        benefits: [
            "Exhibition stall at the conference venue",
            "Free registration for 3 delegates",
            "Logo and name displayed at the stage backdrop",
            "Full-page multi-colour advertisement in the souvenir",
        ],
    },
    {
        key: "bronze",
        name: "Bronze Sponsor",
        price: "3,00,000",
        accent: "#b45309",
        icon: <FaMedal />,
        benefits: [
            "Exhibition stall at the conference venue",
            "Free registration for 2 delegates",
            "Logo and name displayed at the stage backdrop",
            "Full-page multi-colour advertisement in the souvenir",
        ],
    },
    {
        key: "souvenir",
        name: "Souvenir Advertisement",
        price: "1,00,000",
        accent: "#1c4fa0",
        icon: <FaBook />,
        benefits: [
            "Invitation to the inaugural function of the conference",
            "Full-page multi-colour advertisement in the souvenir",
        ],
    },
];

const TierRow = ({ tier, index, isLast }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.2 }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            className={`${styles.tierRow} ${visible ? styles.tierRowVisible : ""} ${isLast ? styles.tierRowLast : ""
                }`}
            style={{ "--accent": tier.accent, "--i": index }}
        >
            <div className={styles.tierRail}>
                <div className={styles.tierIcon}>{tier.icon}</div>
            </div>

            <div className={`${styles.tierCard} ${tier.featured ? styles.tierCardFeatured : ""}`}>
                {tier.featured && <span className={styles.tierBadge}>Top Tier</span>}

                <div className={styles.tierCardHead}>
                    <h3 className={styles.tierName}>{tier.name}</h3>

                    <div className={styles.tierPrice}>
                        <span className={styles.tierPriceCurrency}>INR</span>
                        <span className={styles.tierPriceAmount}>{tier.price}</span>
                        <span className={styles.tierPriceSuffix}>/-</span>
                    </div>
                </div>

                <ul className={styles.tierList}>
                    {tier.benefits.map((benefit, i) => (
                        <li key={i}>{benefit}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const SponsorsPage = () => {
    return (
        <div className={styles.page}>
            <section className={styles.hero}>
                <span className={styles.heroEyebrow}>IVEC 2027</span>
                <h1 className={styles.heroTitle}>Sponsorship Opportunities</h1>
                <p className={styles.heroTagline}>
                    An exhibition will be arranged at the conference venue.
                    Industry partners are invited to utilize the event to
                    highlight their products and capabilities to the
                    distinguished delegates.
                </p>
            </section>

            <section className={styles.ladder}>
                {TIERS.map((tier, index) => (
                    <TierRow
                        key={tier.key}
                        tier={tier}
                        index={index}
                        isLast={index === TIERS.length - 1}
                    />
                ))}
            </section>

            <section className={styles.contact}>
                <div className={styles.contactIcon}>
                    <FaStore />
                </div>

                <div className={styles.contactBody}>
                    <strong>Any queries on sponsorship may please be directed to:</strong>

                    <div className={styles.contactDetails}>
                        <span>
                            <FaUserTie /> Khilawan Choudhary
                        </span>
                        <span>
                            <FaLandmark /> Treasurer, VEDA Society
                        </span>
                        <a href="mailto:veda.treasurer@gmail.com">
                            <FaEnvelope /> veda.treasurer@gmail.com
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SponsorsPage;